/// \file releaseNotes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const ReleaseNotesList = lazy(() => import('../views/release-notes/list/view'));

async function ReleaseNotesDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/release-notes/list/loader')).default;
  return actualLoader(args);
}

export async function ReleaseNotesAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/release-notes/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="release-notes"
    handle={{
      text:"RELEASE NOTES"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <ReleaseNotesList />
        </Suspense>
      }
      loader={ReleaseNotesDataLoader}
      action={ReleaseNotesAction}
      />
  </Route>
);

export default routes;